import axios from "axios";
import { baseApiV2 } from "../../constants/Presets";

export function FetchEpgList(payload) {
  const url = `${baseApiV2}epg_channel_code/list?`;
  const params = [];
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const size = payload.size || 50;
  params.push(`size=${size}`);
  const companyId = payload.companyId || "";
  companyId && params.push(`companyId=${companyId}`);
  const orderBy = payload.orderBy || "";
  orderBy && params.push(`orderBy=${orderBy}`);
  const order = payload.order;
  params.push(`order=${order}`);
  const query = payload.query || "";
  params.push(`query=${query}`);
  const filters = payload.filters || "";
  filters &&
    params.push(`filters=${encodeURIComponent(JSON.stringify(filters))}`);
  params.push("initialLoad=true");
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}
export function addEpgChannel(payload) {
  return axios.post(`${baseApiV2}epg_channel_code/create`, payload);
}

export function updateEpgListItem(payload) {
  return axios({
    method: "PATCH",
    url: `${baseApiV2}epg_channel_code`,
    data: payload,
  });
}

export function deleteEpgChannel(id) {
  const url = `${baseApiV2}epg_channel_code?epg_channel_id=${id}`;
  return axios.delete(url);
}

export function FetchEpgChangeLog(id) {
  const url = `${baseApiV2}epg_channel_code/changeLog`;
  return axios.get(url);
}
